/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T16:58:07+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-05T17:51:13+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import inputProps from 'utilities/inputProps';
import omit from 'lodash/omit';

// these are mistakenly passed properties that will be stripped from rendered prop
const strippedInputProperties = ['pickerFallbackDate', 'startWithYears', 'showErrors', 'withFieldValue'];


/**
 * MInputText - …
**/
class MInputText extends Component {
  render() {
    const {
      value,
      defaultValue,
      placeholder,
      visualState,
      actions,
      disabled,
      error, // eslint-disable-line no-unused-vars
      type,
      unit,
      mask,
      onChange,
      fieldValue,
      onPress,
      autoComplete,
      ...other
    } = this.props;

    let actionsEl;

    if (actions) {
      actionsEl = (
        <div className="m-input-text__actions">
          {actions}
        </div>
      );
    }

    const unitEl = (!unit) ? null : <div className="m-input-text__unit">
      <span className={`a-icon a-icon-inline glyphicons glyphicons-${unit} small`}/>
    </div>;

    const inputCommonProps = {
      className: 'm-input-text__input',
      id: this._id || other.id,
      value,
      defaultValue,
      placeholder,
      disabled,
      type,
      onClick: onPress,
      onChange,
    };

    const inputEl = (mask) ?
            React.createElement(MaskedInput, {
              ...omit(other, strippedInputProperties),
              ...inputCommonProps,
              mask,
              // workaound for https://github.com/text-mask/text-mask/issues/220
              autoComplete: ( navigator != undefined ) && navigator.userAgent.match(/Android/) ? 'off' : null,
            })
         :
             React.createElement('input', {
               ...omit(other, strippedInputProperties),
               ...inputCommonProps,
               autoComplete,
             })
         ;

    const isValid = fieldValue && fieldValue.touched && fieldValue.valid;

    return (
      <div className={`m-input m-input-text ${visualState}${isValid ? ' valid' : ''}`}>
        <div className="m-input-text__inputfield">
          {inputEl}
        </div>
        {unitEl}
        {actionsEl}
      </div>
    );
  }
}
MInputText.propTypes = {
  /**
     * id of the input field to link it with a labels htmlFor attribute
     */
  id: PropTypes.string,
  /**
     * value to use the field as controlled input
     * NOTE: it may occure strange behaviour when using it as
     * a controlled component with a mask and parsed values ...
     * Keep it in mind and test what you are doing.
     */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  /**
     * default value, use it, if it is not a controled comp
     */
  defaultValue: PropTypes.string,
  /**
     * placholder value
     */
  placeholder: PropTypes.string,
  /**
     * disable the input field
     */
  disabled: PropTypes.bool,
  /**
     * show the error state
     */
  error: PropTypes.bool,
  /**
     * one or more react elements of type AButton like AButtonIconInput
     * or similar. Displays the actions on the right
     */
  actions: PropTypes.any,
  /**
     * html input type like text, email, ...
     */
  type: PropTypes.string,
  /**
     * optionally display a unit on the right
     */
  unit: PropTypes.string,
  /**
     * fired when the input-field was clicked
     */
  onPress: PropTypes.func,
  /**
     * force a format for the value based on text-mask
     * see more here: https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#mask
     * https://github.com/text-mask/text-mask/tree/master/addons#createnumbermask
     */
  mask: PropTypes.any,

  fieldValue: PropTypes.any,
  /**
     * when the input field changes, passes (event)
     */
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  visualState: PropTypes.string, // passed by inputProps
  showErrors: PropTypes.any, // passed by inputProps
};
MInputText.defaultProps = {
  type: 'text',
  error: false,
};
export default inputProps(MInputText);

